import { UploadChangeParam } from 'antd/lib/upload';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadFile } from 'antd/lib/upload/interface';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COMMON_ERROR, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { NEW_UPLOAD_STATUS, UPLOAD_STATUS } from '../../../shared/constants/crmConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { RootState } from '../../../store';
import { setUploadedFiles } from '../../../store/actions/inPatientAction';
import { fileBeforeUpload } from '../../../utils/fileUploadUtils';
import { centeredNotification, sortByUid } from '../../../utils/utility';
import { ReactComponent as UploadIcon } from '../../../assets/images/svg/drive_folder_upload.svg';
import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import BuddhiMedUploadListItem from '../../../shared/components/fileUpload/BuddhiMedUploadListItem';

const FileUploader = ({allowedFileTypes = '', isDocumentTypeRequired = true}: any): ReactElement => {
  const { uploadedFiles: fileList } = useSelector((state: RootState): any => state.selectedInPatientDetail || {});
  const { payerList: { payer} } = useSelector((state: RootState): any => state);
  const { id: payerId } = payer;
  const dispatch = useDispatch();
  const ALLOWED_FILE_EXTENSIONS = ApplicationDetail.instance.getAllowedFileExtension();

  const draggerActions = {
    fileList,
    name: 'file',
    data: {payerId},
    multiple: true,
    action: GLOBAL_URL.CRM_BASE_URL + 'Provider/File/Upload',
    withCredentials : true,
    beforeUpload: (event: any): any => fileBeforeUpload(event, payer),
    onChange: (fileInfo: UploadChangeParam<any>): void => {
      const { file: { response, status: fileStatus, existingRecord, uid: currFileUid }, event, fileList: fList } = fileInfo;
      if (fileStatus === UPLOAD_STATUS.done) {
        const { isSuccess, uploadedDetails, errors, errorMessage } = response;
        if (!existingRecord && isSuccess && uploadedDetails && uploadedDetails.length) {
        } else if (!isSuccess) {
          const brokenFileIndex = fList.findIndex((ele: any): boolean => ele?.uid === currFileUid);
          fList.splice(brokenFileIndex, 1);
          dispatch(setUploadedFiles([...sortByUid(fList)]));
          centeredNotification(errorMessage || errors?.join('\n') || COMMON_ERROR);
        }
      } else if (!fileStatus) {
        const perfectFileList = fList.filter((ele: any): boolean => ele?.uid !== currFileUid);
        dispatch(setUploadedFiles([...sortByUid(perfectFileList)]));
      }

      if (!event?.percent && fileStatus !== 'error' && response?.isSuccess) {
        fList.map((element: any): any => {
          element['claimStatus'] = element['claimStatus'] ? element['claimStatus'] : NEW_UPLOAD_STATUS;
          return element;
        });
        dispatch(setUploadedFiles([...sortByUid(fList)]));
      }
    },
  };

  const draggerItemRender = (): null => null;

  const onRemove = (selectedUid: string): void => {
    const index = [...fileList].findIndex(({ uid }: any): boolean => uid === selectedUid);
    fileList.splice(index, 1);
    dispatch(setUploadedFiles([...fileList]));
  };

  let filesGroupByStatus = fileList.reduce((result: any, currentElement: any): any => {
    result[currentElement?.claimStatus] = [...result[currentElement?.claimStatus] || [], currentElement];
    return result;
  }, {});

  if (filesGroupByStatus[NEW_UPLOAD_STATUS]) {
    const temp = filesGroupByStatus[NEW_UPLOAD_STATUS];
    delete filesGroupByStatus[NEW_UPLOAD_STATUS];
    filesGroupByStatus = {
      [NEW_UPLOAD_STATUS]: temp,
      ...filesGroupByStatus,
    };
  }

  return (
    <div>
      {
      fileList?.length ?
        <Row gutter={GUTTOR_SPACE} className="mb-sm">
          <Col md={6}><strong>Documents</strong></Col>
          <Col md={8}><strong>Uploaded on</strong></Col>
          <Col md={7}><strong>Status</strong></Col>
          <Col md={3}><strong>Remove</strong></Col>
        </Row> : null
    }
    {
      Object.keys(filesGroupByStatus).map((statusKey: string): any => (
        <div key={statusKey + Date.now()}>
          <Text type="secondary">{statusKey}</Text>
          {filesGroupByStatus[statusKey].map((file: UploadFile | any, index: number): ReactElement | null =>
            <BuddhiMedUploadListItem file={file} key={file.uid} index={index}
              onRemove={onRemove} fileListLength={filesGroupByStatus[statusKey].length}
              isDocumentTypeRequired={isDocumentTypeRequired} />)}
        </div>
      ))
    }
      <Dragger
        {...draggerActions}
        itemRender={draggerItemRender}
        id="dragger"
        className="file-upload-dragger"
        data-testid="dropzone">
        <div className="flex flex-element flex-row">
          <div className="flex-element justify-center items-center mr-10">
            <UploadIcon className="fill-primary upload-file-icon-buddhimed"/>
          </div>
          <div className="flex-element flex-col justify-center items-center w-90">
            <b className="ant-upload-text"> Drag & Drop your file(s) here. </b>
            <p className="ant-upload-hint w-90 "> File format needs to be {allowedFileTypes?.length > 0 ?
            allowedFileTypes : payer?.allowedFileTypes?.length > 0 ?
            payer?.allowedFileTypes : ALLOWED_FILE_EXTENSIONS.LABEL}</p>
          </div>
        </div>
      </Dragger>
    </div>
  );
};

export default FileUploader;
